export default "__VITE_ASSET__DDgBXROS__"